<div class="row files-view" (window:resize)="resize()" #root_div>
  @for (file of this.files; track file.id) {
    <div class="file-view">
      <div class="attach" (click)="onFileClick(file)">
        @if (file.isImage()) {
          <img src="{{ file.thumbnail }}" />
        } @else {
          <div class="file-format"><i [ngClass]="file.file_name | fileIconClass"></i></div>
          @if (!file.canPreview() && !file.isPdf()) {
            <a class="action-file">
              <i class="fa fa-download"></i>
            </a>
          }
        }
      </div>
      <p class="file-name" (click)="onFileClick(file)">{{ file.file_name }}</p>
      <p class="caption">{{ file.caption }}</p>
    </div>
  }
  <app-story-gallery [items]="previewFiles()" #gallery></app-story-gallery>
</div>
